import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, factory, Input, InputBase, Text, useCombobox, useProps, useUncontrolled } from '@coveord/plasma-mantine';
import { InfiniteScroll } from '../InfiniteScroll.js';
import { groupOptions } from '../../../utilities/group-options.js';
var DefaultInfiniteScrollSelectItem = function DefaultInfiniteScrollSelectItem(param) {
    var selected = param.selected, data = param.data;
    return /*#__PURE__*/ _jsx(Text, {
        fw: selected ? 500 : 400,
        children: data.label
    });
};
var defaultProps = {
    searchPlaceholder: 'Search',
    nothingFoundMessage: 'No matching items',
    placeholder: 'No items',
    height: 200,
    limit: Infinity,
    itemComponent: DefaultInfiniteScrollSelectItem
};
export var InfiniteScrollSelect = factory(function(_props, ref) {
    var _data_find;
    var props = useProps('InfiniteScrollSelect', defaultProps, _props);
    var data = props.data, onChange = props.onChange, _props_defaultValue = props.defaultValue, defaultValue = _props_defaultValue === void 0 ? null : _props_defaultValue, value = props.value, ItemComponent = props.itemComponent, searchPlaceholder = props.searchPlaceholder, query = props.query, _props_searchable = props.searchable, searchable = _props_searchable === void 0 ? data.length > 7 : _props_searchable, onSearch = props.onSearch, _props_filter = props.filter, filter = _props_filter === void 0 ? defaultFilter : _props_filter, nothingFoundMessage = props.nothingFoundMessage, placeholder = props.placeholder, height = props.height, radius = props.radius, __staticSelector = props.__staticSelector, classNames = props.classNames, styles = props.styles, limit = props.limit, vars = props.vars, unstyled = props.unstyled, description = props.description, label = props.label, others = _object_without_properties(props, [
        "data",
        "onChange",
        "defaultValue",
        "value",
        "itemComponent",
        "searchPlaceholder",
        "query",
        "searchable",
        "onSearch",
        "filter",
        "nothingFoundMessage",
        "placeholder",
        "height",
        "radius",
        "__staticSelector",
        "classNames",
        "styles",
        "limit",
        "vars",
        "unstyled",
        "description",
        "label"
    ]);
    var combobox = useCombobox({
        onDropdownClose: function onDropdownClose() {
            combobox.resetSelectedOption();
            combobox.focusTarget();
            handleSearch('');
        },
        onDropdownOpen: function onDropdownOpen() {
            combobox.focusSearchInput();
        }
    });
    var _useUncontrolled = _sliced_to_array(useUncontrolled({
        value: query,
        defaultValue: '',
        finalValue: '',
        onChange: onSearch
    }), 2), search = _useUncontrolled[0], handleSearch = _useUncontrolled[1];
    var _useUncontrolled1 = _sliced_to_array(useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    }), 2), _selection = _useUncontrolled1[0], handleSelection = _useUncontrolled1[1];
    var filteredData = data.filter(function(item) {
        return filter(search, item);
    }).slice(0, limit);
    var selectedLabel = (_data_find = data.find(function(item) {
        return item.value === _selection;
    })) === null || _data_find === void 0 ? void 0 : _data_find.label;
    var sortedData = groupOptions({
        data: filteredData
    }).map(function(item) {
        return /*#__PURE__*/ _jsx(Combobox.Option, {
            active: _selection === item.value,
            "aria-selected": _selection === item.value,
            value: item.value,
            onMouseEnter: function onMouseEnter() {
                return combobox.resetSelectedOption();
            },
            children: /*#__PURE__*/ _jsx(ItemComponent, {
                data: item,
                selected: _selection === item.value
            })
        }, item.value);
    });
    var handleValueSelect = function handleValueSelect(val) {
        handleSelection(val);
        combobox.closeDropdown();
    };
    return /*#__PURE__*/ _jsxs(Combobox, _object_spread_props(_object_spread({
        store: combobox,
        onOptionSubmit: handleValueSelect
    }, others), {
        children: [
            /*#__PURE__*/ _jsx(Combobox.Target, {
                children: /*#__PURE__*/ _jsx(InputBase, {
                    component: "button",
                    label: label,
                    description: description,
                    type: "button",
                    pointer: true,
                    rightSection: /*#__PURE__*/ _jsx(Combobox.Chevron, {}),
                    onClick: function onClick() {
                        return combobox.toggleDropdown();
                    },
                    rightSectionPointerEvents: "none",
                    children: selectedLabel || /*#__PURE__*/ _jsx(Input.Placeholder, {
                        children: placeholder
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Combobox.Dropdown, {
                children: [
                    /*#__PURE__*/ _jsx(Combobox.Search, {
                        value: search,
                        onChange: function onChange(event) {
                            return handleSearch(event.currentTarget.value);
                        },
                        placeholder: searchPlaceholder
                    }),
                    /*#__PURE__*/ _jsx(Combobox.Options, {
                        children: /*#__PURE__*/ _jsx(InfiniteScroll, {
                            style: {
                                height: searchable ? height : 'auto',
                                overflow: 'auto',
                                position: 'relative'
                            },
                            children: sortedData.length > 0 ? sortedData : /*#__PURE__*/ _jsx(Combobox.Empty, {
                                children: /*#__PURE__*/ _jsx(Text, {
                                    c: "dimmed",
                                    unstyled: unstyled,
                                    size: "sm",
                                    ta: "center",
                                    my: "sm",
                                    children: !query && placeholder ? placeholder : nothingFoundMessage
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
});
InfiniteScrollSelect.displayName = 'InfiniteScrollSelect';
var defaultFilter = function defaultFilter(query, item) {
    return item.label.toLowerCase().trim().includes(query.toLowerCase().trim()) || item.value.toLowerCase().trim().includes(query.toLowerCase().trim());
};

//# sourceMappingURL=InfiniteScrollSelect.js.map